import ContentLoader from "react-content-loader";
import React from "react";

import { DashboardCard2 } from "@/components/layout/DashboardCard2";

const ProfileLoader = () => {
  const ProfileContentLoader = () => (
    <DashboardCard2 rawChildren>
      <ContentLoader
        height={400}
        primaryColor="#f3f3f3"
        secondaryColor="#ecebeb"
        speed={2}
        width={900}
      >
        <rect height="10" rx="5" ry="5" width="150" x="25" y="100" />
        <rect height="10" rx="5" ry="5" width="150" x="375" y="100" />
        <rect height="10" rx="5" ry="5" width="150" x="25" y="120" />
        <rect height="10" rx="5" ry="5" width="150" x="375" y="120" />
        <rect height="10" rx="5" ry="5" width="150" x="25" y="180" />
        <rect height="10" rx="5" ry="5" width="150" x="375" y="180" />
        <rect height="10" rx="5" ry="5" width="150" x="25" y="200" />
        <rect height="10" rx="5" ry="5" width="150" x="375" y="200" />
        <rect height="10" rx="5" ry="5" width="150" x="25" y="260" />
        <rect height="10" rx="5" ry="5" width="150" x="375" y="260" />
        <rect height="10" rx="5" ry="5" width="150" x="25" y="285" />
        <rect height="10" rx="5" ry="5" width="150" x="375" y="285" />
      </ContentLoader>
    </DashboardCard2>
  );

  const ProfileAvtarLoader = () => (
    <DashboardCard2 rawChildren>
      <ContentLoader
        height={560}
        primaryColor="#f3f3f3"
        secondaryColor="#ecebeb"
        speed={2}
        width={400}
      >
        <rect height="10" rx="3" ry="3" width="200" x="100" y="350" />
        <rect height="10" rx="3" ry="3" width="200" x="100" y="320" />
        <circle cx="200" cy="200" r="90" />
      </ContentLoader>
    </DashboardCard2>
  );

  return (
    <div className="container px-3">
      <div className="PatientProfile">
        <div className="row">
          <div className="col-12 col-lg-3 mt-3 mt-lg-0 mb-3 mb-lg-0">
            <div className="PatientProfile__ProfileDetailsCard">{ProfileAvtarLoader()}</div>
          </div>
          <div className="col-12 col-lg-9 mt-3 mt-lg-0 mb-3 mb-lg-0">
            <div className="PatientProfile__ProfileDetailsCard">{ProfileContentLoader()}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileLoader;
